// 基础配置（注意结尾的斜杠）
const BASE_URL = 'https://www.vtimes.net.cn/vtimesPhpAdmin/';

/**
 * 构建完整请求地址
 * @param {string} path - 接口路径（如：save_achievements.php）
 * @param {object} [params] - URL 查询参数
 * @returns {string} 完整 URL
 */
const buildUrl = (path, params) => {
	// 确保路径不以斜杠开头
	const normalizedPath = path.startsWith('/') ? path.slice(1) : path;
	const url = new URL(normalizedPath, BASE_URL);

	// 添加查询参数
	if (params) {
		Object.entries(params).forEach(([key, value]) => {
			url.searchParams.append(key, value);
		});
	}
	return url.toString();
};
/**
 * 通用请求方法
 * @param {'GET'|'POST'|'PUT'|'DELETE'} method - HTTP 方法
 * @param {string} path - 接口路径
 * @param {object} [data] - 请求主体数据
 * @param {object} [params] - URL 查询参数
 * @returns {Promise<Response>}
 */
const request = async (method, path, data, params) => {
	const url = buildUrl(path, params);

	const options = {
		method,
		headers: {
			'Content-Type': 'application/json',
		},
	};

	if (method !== 'GET' && data) {
		options.body = JSON.stringify(data);
	}

	return fetch(url, options);
};

export const api = {
	get: (path, params) => request('GET', path, null, params),
	post: (path, data) => request('POST', path, data),
	put: (path, data) => request('PUT', path, data),
	delete: (path, data) => request('DELETE', path, data),
};